<template>
  <div class="collapse">
    <div class="collapse_container">
      <div v-for="(item, index) in digitalEnergy" :key="index" class="item">
        <div class="title">
          <!-- <img> -->
          <span>{{ item.icon[index] }}</span><span>{{ item.title }}</span>
        </div>
        <div v-if="index===0" class="content">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { digitalEnergy } from '../../util/constant'
export default {
  data() {
    return {
      activeIndex: 0,
      digitalEnergy
    };
  },
  methods: {
    switchBox(index) {
      if (index !== this.activeIndex) {
        const boxes = document.querySelectorAll('.box');
        const firstBox = boxes[0];
        const clickedBox = boxes[index];
        const lastBox = boxes[boxes.length - 1];

        if (index > this.activeIndex) {
          firstBox.classList.remove('blue'); // 移除第一栏的蓝色状态
          firstBox.style.animationName = 'moveUp';
          lastBox.style.animationName = 'moveDown';
        } else {
          firstBox.classList.remove('blue'); // 移除第一栏的蓝色状态
          firstBox.style.animationName = 'moveDown';
          clickedBox.style.animationName = 'moveUp';
        }

        this.activeIndex = index;

        setTimeout(() => {
          const parent = firstBox.parentNode;
          parent.removeChild(firstBox);
          parent.appendChild(firstBox);
          firstBox.classList.add('blue'); // 添加第一栏的蓝色状态
          boxes.forEach(box => (box.style.animationName = ''));
        }, 500);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.collapse{
  background-color: coral;
  .collapse_container{
    margin: 0 auto;
    width: 80%;
    background-color: aqua;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
  }
}
.item {
  width: 50%;
  // height: 100px;
  background-color: gray;
  margin: 10px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  cursor: pointer;
  transition: all 0.5s;
}

.blue {
  background-color: blue;
}

@keyframes moveUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-120%);
  }
}

@keyframes moveDown {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(120%);
  }
}
</style>
